var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Main',{attrs:{"title":_vm.title,"theme-type":_vm.themeType,"height":_vm.height,"columns":_vm.tableColumns,"data":_vm.tableData,"loading":_vm.loading,"tableKey":_vm.tableKey},on:{"upload-change":_vm.uploadChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }